module.exports = __webpack_public_path__ + "img/theo-big-phone.da23a9bc.svg";